import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../../core/services';
import { GenericService } from '../../../../core/services/GenericService';
import { IProductSetupDetail, IProductSetupListItem } from '../interfaces/IProductSetup';
import { IMySetupStep, IOpenSetupStep } from '../interfaces/IProductSetupWidgets';

@Injectable({
  providedIn: 'root'
})
export class ProductSetupsService extends GenericService<IProductSetupListItem> {
  protected baseUrl = '/product-setups';

  constructor(public apiService: ApiService) {
    super(apiService);
  }

  create(name: string | IProductSetupListItem): Observable<IProductSetupDetail> {
    const body = typeof name === 'string' ? { name } : name;
    return this.apiService.post(this.baseUrl, body);
  }

  getById(id: string | number): Observable<IProductSetupDetail> {
    return this.apiService.get(`${this.baseUrl}/${id}`);
  }

  saveRemark(id: number, remark: string): Observable<void> {
    return this.apiService.put(`${this.baseUrl}/${id}/remark`, { remark });
  }

  linkArticle(id: number, articleVariantId: number | null): Observable<void> {
    return this.apiService.put(`${this.baseUrl}/${id}/article`, { articleVariantId });
  }

  confirm(id: number, stepId: number): Observable<void> {
    return this.apiService.post(`${this.baseUrl}/${id}/steps/${stepId}/confirm`);
  }

  withdraw(id: number, stepId: number): Observable<void> {
    return this.apiService.post(`${this.baseUrl}/${id}/steps/${stepId}/withdraw`);
  }

  mine(): Observable<IMySetupStep[]> {
    return this.apiService.get(`${this.baseUrl}/mine`);
  }

  open(): Observable<IOpenSetupStep[]> {
    return this.apiService.get(`${this.baseUrl}/open`);
  }
}
